import styled from 'styled-components';
import styledTheme from 'common/theme';

interface StyledTableContainerProps {
  disableMaxHeight?: boolean;
}

export const StyledTableContainer = styled.div<StyledTableContainerProps>`
  ${props => !props.disableMaxHeight && 'max-height: 400px;'}
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 17% 33%;
  gap: 0px;
  width: 100%;

  .first-header, .first-row-item {
    margin-left: 35px;
  }

  > :not(.first-header) {
    text-align: right;
    padding-right: 10px;
  }

  .first-row-item {
    text-align: left;
    word-wrap: break-word;
  }
`;

export const HeaderCell = styled.div`
  font-weight: bold;
  border-bottom: 1px solid ${(props) => props.theme.colors.lightGrey3};
  font-size: 0.8rem;
  padding-bottom: 4px;
  padding-left: 5px;
`;

export const SectionHeading = styled.div`
  grid-column: 1 / -1;
  font-size: 0.875rem;
  font-weight: 600;
  margin: 10px 0;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const InnerHeader = styled.div`
  display: contents;
  font-weight: bold;
  font-size: 0.8rem;

  .inner-header {
    padding: 10px 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.lightGrey3};
    &:not(.first-header) {
      padding-left: 5px;
      text-align: right;
      padding-right: 5px;
    }
  }
`;

export const RowItem = styled.div`
  padding: 8px 0px 8px 5px;
  font-size: 0.8rem;
  font-weight: 500;

  &.first-row-item {
    color: ${styledTheme.colors.gray800};
  }

  &.error-color {
    color: ${(props) => props.theme.colors.error200};
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 10px;
    text-decoration: underline;
  }
`;

export const ActualValueMsg = styled.div`
  font-weight: 600;
`;

export const ToolTipTextMsg = styled.div`
  font-weight: 600;
  cursor: pointer;
`;
